<template>
    <div>
        <template v-if="isVisible">
            <vue-html2pdf 
    
                :show-layout="false" 
                :float-layout="true" 
                :enable-download="true" 
                :preview-modal="true" 
                filename="gwapo" 
                :pdf-quality="2" 
                :manual-pagination="true" 
                :paginate-elements-by-height="1100"
                pdf-format="a4" 
                pdf-orientation="portrait" 
                pdf-content-width="710px" 
                :html-to-pdf-options="htmlToPdfOptions"
                @progress="onProgress" 
                @hasStartedGeneration="hasStartedGeneration" 
                @hasGenerated="hasGenerated" 
                @hasDownloaded="hasDownloaded"
                ref="html2Pdf" 
            > 
    
                <section slot="pdf-content" class="pdf-content"> 
                    <div class="eod-report-main-container" id="eod-report-main-container">
                        <div class="eod-container d-flex flex-column gap-20">
                            <!-- <el-button type="success" @click="convertToPDF">to PDF</el-button> -->
                            <span class="title text-center">END OF THE DAY REPORT</span>
    
                            <div class="top-content-container d-flex gap-5 flex-column">
                                <div class="d-flex justify-content-between gap-5">
                                    <div class="label">
                                        Venue Name: 
                                        <span class="font-weight-bold">Ivan's Test Account</span>
                                    </div>
    
                                    <div class="label">
                                        Date Generated: 
                                        <span class="font-weight-bold">August 1, 2023 12:24 pm</span>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between gap-5">
                                    <div class="label">
                                        Manager on Duty: 
                                        <span class="font-weight-bold">Ivan Brewer</span>
                                    </div>
                                </div>
                            </div>
    
                            <div class="header-title">
                                END OF THE DAY SUMMARY
                            </div>
    
                            <div class="summary-container d-flex gap-16">
                                <div class="content d-flex flex-column">
                                    <div class="d-flex wrapper">
                                        <div class="label w-100">
                                            Revenue Actual
                                        </div>
                                        <div class="value text-right w-100">
                                            $6,500.00
                                        </div>
                                    </div>
    
                                    <div class="d-flex wrapper">
                                        <div class="label w-100">
                                            Target Revenue
                                        </div>
                                        <div class="value text-right w-100">
                                            $4,500.00
                                        </div>
                                    </div>
    
                                    <div class="d-flex wrapper font-weight-bold">
                                        <div class="label w-100">
                                            Variance
                                        </div>
                                        <div class="value text-right w-100 green">
                                            +$2,000.00
                                        </div>
                                    </div>
                                </div>
                                <div class="content d-flex flex-column">
                                    <div class="d-flex wrapper">
                                        <div class="label w-100">
                                            Labour Actual
                                        </div>
                                        <div class="value text-right w-100">
                                            $3,500.00
                                        </div>
                                    </div>
    
                                    <div class="d-flex wrapper">
                                        <div class="label w-100">
                                            Labour Target
                                        </div>
                                        <div class="value text-right w-100">
                                            $4,000.00
                                        </div>
                                    </div>
    
                                    <div class="d-flex wrapper font-weight-bold">
                                        <div class="label w-100">
                                            Variance
                                        </div>
                                        <div class="value text-right w-100 green">
                                            -$500.00
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="summary-container d-flex">
                                <div class="content d-flex flex-column">
                                    <div class="other-label border-all text-center w-100">
                                        Cash tips
                                    </div>
                                    <div class="other-value border-all no-top text-center font-weight-bold w-100">
                                        $100.00
                                    </div>
                                </div>
                                <div class="content d-flex flex-column">
                                    <div class="other-label border-all no-left text-center w-100">
                                        Till Variance
                                    </div>
                                    <div class="other-value border-all no-left no-top text-center font-weight-bold green w-100">
                                        +$20.00
                                    </div>
                                </div>
                                <div class="content d-flex flex-column">
                                    <div class="other-label border-all no-left text-center w-100">
                                        Cover
                                    </div>
                                    <div class="other-value border-all no-left no-top text-center font-weight-bold w-100">
                                        10
                                    </div>
                                </div>
                                <div class="content d-flex flex-column">
                                    <div class="other-label border-all no-left text-center w-100">
                                        SPH
                                    </div>
                                    <div class="other-value border-all no-left no-top text-center font-weight-bold w-100">
                                        $650.00
                                    </div>
                                </div>
                            </div>
    
                            <div class="header-title">
                                STAFF WORKING WITH VARIANCE
                            </div>
                            <div class="summary-container d-flex gap-16">
                                <div class="content d-flex flex-column">
                                    
                                    <div class="d-flex wrapper">
                                        <div class="label w-100">
                                            Menard Catayas
                                        </div>
                                        <div class="value text-right right red w-100">
                                            1.5 Hrs
                                        </div>
                                    </div>
                                    <div class="d-flex wrapper">
                                        <div class="label w-100">
                                            Peter Pons
                                        </div>
                                        <div class="value text-right right red w-100">
                                            2.0 Hrs
                                        </div>
                                    </div>
                                    <div class="d-flex wrapper">
                                        <div class="label w-100">
                                            Wendell Karingal
                                        </div>
                                        <div class="value text-right right red w-100">
                                            1.2 Hrs.
                                        </div>
                                    </div>
                                    <div class="d-flex wrapper">
                                        <div class="label w-100 font-weight-bold">
                                            Total Variance
                                        </div>
                                        <div class="value text-right right font-weight-bold red w-100">
                                            4.7 Hrs
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="feedback-container d-flex flex-column gap-10">
                                <span class="font-weight-bold">Summary</span>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                </p>
                            </div>
    
                            <div class="feedback-container d-flex flex-column gap-10">
                                <span class="font-weight-bold">Guest Feedback</span>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                </p>
                            </div>
    
                            <div class="feedback-container d-flex flex-column gap-10">
                                <span class="font-weight-bold">Staff Feedback</span>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                </p>
                            </div>
    
                            <div class="feedback-container d-flex flex-column gap-10">
                                <span class="font-weight-bold">Maintenance</span>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                                </p>
                            </div>
                            
                        </div>
                    </div>
                </section> 
    
            </vue-html2pdf> 
    
            <div class="eod-report-main-container" id="eod-report-main-container">
                <div class="eod-container d-flex flex-column gap-20">
                    <el-button type="success" class="download-button" @click="generateReport">Download PDF</el-button>
                    <span class="title text-center">END OF THE DAY REPORT</span>
    
                    <div class="top-content-container d-flex gap-5 flex-column">
                        <div class="d-flex justify-content-between gap-5">
                            <div class="label">
                                Venue Name: 
                                <span class="font-weight-bold">Ivan's Test Account</span>
                            </div>
    
                            <div class="label">
                                Date Generated: 
                                <span class="font-weight-bold">August 1, 2023 12:24 pm</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between gap-5">
                            <div class="label">
                                Manager on Duty: 
                                <span class="font-weight-bold">Ivan Brewer</span>
                            </div>
                        </div>
                    </div>
    
                    <div class="header-title">
                        END OF THE DAY SUMMARY
                    </div>
    
                    <div class="summary-container d-flex gap-16">
                        <div class="content d-flex flex-column">
                            <div class="d-flex wrapper">
                                <div class="label w-100">
                                    Revenue Actual
                                </div>
                                <div class="value text-right w-100">
                                    $6,500.00
                                </div>
                            </div>
    
                            <div class="d-flex wrapper">
                                <div class="label w-100">
                                    Target Revenue
                                </div>
                                <div class="value text-right w-100">
                                    $4,500.00
                                </div>
                            </div>
    
                            <div class="d-flex wrapper font-weight-bold">
                                <div class="label w-100">
                                    Variance
                                </div>
                                <div class="value text-right w-100 green">
                                    +$2,000.00
                                </div>
                            </div>
                        </div>
                        <div class="content d-flex flex-column">
                            <div class="d-flex wrapper">
                                <div class="label w-100">
                                    Labour Actual
                                </div>
                                <div class="value text-right w-100">
                                    $3,500.00
                                </div>
                            </div>
    
                            <div class="d-flex wrapper">
                                <div class="label w-100">
                                    Labour Target
                                </div>
                                <div class="value text-right w-100">
                                    $4,000.00
                                </div>
                            </div>
    
                            <div class="d-flex wrapper font-weight-bold">
                                <div class="label w-100">
                                    Variance
                                </div>
                                <div class="value text-right w-100 green">
                                    -$500.00
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="summary-container d-flex">
                        <div class="content d-flex flex-column">
                            <div class="other-label border-all text-center w-100">
                                Cash tips
                            </div>
                            <div class="other-value border-all no-top text-center font-weight-bold w-100">
                                $100.00
                            </div>
                        </div>
                        <div class="content d-flex flex-column">
                            <div class="other-label border-all no-left text-center w-100">
                                Till Variance
                            </div>
                            <div class="other-value border-all no-left no-top text-center font-weight-bold green w-100">
                                +$20.00
                            </div>
                        </div>
                        <div class="content d-flex flex-column">
                            <div class="other-label border-all no-left text-center w-100">
                                Cover
                            </div>
                            <div class="other-value border-all no-left no-top text-center font-weight-bold w-100">
                                10
                            </div>
                        </div>
                        <div class="content d-flex flex-column">
                            <div class="other-label border-all no-left text-center w-100">
                                SPH
                            </div>
                            <div class="other-value border-all no-left no-top text-center font-weight-bold w-100">
                                $650.00
                            </div>
                        </div>
                    </div>
    
                    <div class="header-title">
                        STAFF WORKING WITH VARIANCE
                    </div>
    
                    <div class="summary-container d-flex gap-16">
                        <div class="content d-flex flex-column">
                            <div class="d-flex wrapper">
                                <div class="label w-100">
                                    Menard Catayas
                                </div>
                                <div class="value text-right right red w-100">
                                    1.5 Hrs
                                </div>
                            </div>
                            <div class="d-flex wrapper">
                                <div class="label w-100">
                                    Peter Pons
                                </div>
                                <div class="value text-right right red w-100">
                                    2.0 Hrs
                                </div>
                            </div>
                            <div class="d-flex wrapper">
                                <div class="label w-100">
                                    Wendell Karingal
                                </div>
                                <div class="value text-right right red w-100">
                                    1.2 Hrs.
                                </div>
                            </div>
                            <div class="d-flex wrapper">
                                <div class="label w-100 font-weight-bold">
                                    Total Variance
                                </div>
                                <div class="value text-right right font-weight-bold red w-100">
                                    4.7 Hrs
                                </div>
                            </div>
                        </div>
                    </div>  
    
                    <div class="feedback-container d-flex flex-column gap-10">
                        <span class="font-weight-bold">Summary</span>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                        </p>
                    </div>
    
                    <div class="feedback-container d-flex flex-column gap-10">
                        <span class="font-weight-bold">Guest Feedback</span>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                        </p>
                    </div>
    
                    <div class="feedback-container d-flex flex-column gap-10">
                        <span class="font-weight-bold">Staff Feedback</span>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                        </p>
                    </div>
    
                    <div class="feedback-container d-flex flex-column gap-10">
                        <span class="font-weight-bold">Maintenance</span>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                        </p>
                    </div>
                    
                </div>
            </div>
        </template>
        
        <template v-if="!isVisible">
           <el-dialog class="eod-password" :visible.sync="filePassword" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <div class="eod-password-container d-flex flex-column">
                    <span>ENTER PASSWORD: </span>
                    <el-input type="password" v-model="password" class="peiso-input-default"></el-input>
                    <div class="d-flex justify-content-end">
                        <el-button class="eod-button" @click="isVisible = !isVisible">ENTER</el-button>
                    </div>
                </div>
           </el-dialog>
        </template>
    </div>
</template>

<style lang='scss'>
@import 'static/scss/eod';
</style>

<script>
    import VueHtml2pdf from 'vue-html2pdf' 
    export default {
        data() {
            return {
                htmlToPdfOptions: {
                    margin: 10,
                },
                isVisible: false,
                filePassword: true,
                password: '',
                fileName: null,
            }
        },
        props: {
            
        },
        watch: {
            
        },
        computed: {
            
        },
        components: {
            VueHtml2pdf 
        },
        methods: {
            // convertToPDF() {

            //     var script = document.createElement('script');
            //     script.type = 'application/javascript';
            //     script.src = 'https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js';
            //     document.head.appendChild(script);
            //     var element = document.getElementById('eod-report-main-container');

            //     html2pdf(element);
            // },
            generateReport () { 
                // this.fileName = Math.random()*100
                this.htmlToPdfOptions.filename = Math.random().toString(36).slice(2)
                console.log(Math.random().toString(36).slice(2))
                this.$refs.html2Pdf.generatePdf() 
            },
            onProgress(e) {
                console.log(e, 'progress')
            },
            hasStartedGeneration(e) {
                console.log(e, 'hasStartedGeneration')
            },

            hasGenerated(e) {
                console.log(e, 'hasGenerated')
            },
            hasDownloaded(e) {
                var file = e
                console.log(file, 'hasDownloaded')
            }


        },
        mounted() {
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/report/eod/index.vue